import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/logo";
import { ArrowUpRight, MenuIcon } from "@/components/icons";
import { useAuth } from "@/src/auth-context";

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { user, loading } = useAuth();

  return (
    <header className="site-header">
      <div className="shell site-header__inner">
        <Logo />
        <nav className={`site-nav ${open ? "site-nav--open" : ""}`} aria-label="Primary navigation">
          <Link to="/jobs" onClick={() => setOpen(false)}>Find jobs</Link>
          <Link to="/#why-chuno" onClick={() => setOpen(false)}>Why Chuno</Link>
          <Link to="/about" onClick={() => setOpen(false)}>About</Link>
          <Link to="/contact" onClick={() => setOpen(false)}>Contact</Link>
          <Link className="nav-account" to={!loading && user ? "/dashboard" : "/login"} onClick={() => setOpen(false)}>{!loading && user ? "Dashboard" : "Sign in"}</Link>
          <Link className="nav-cta" to="/jobs" onClick={() => setOpen(false)}>
            Explore openings <ArrowUpRight />
          </Link>
        </nav>
        <button
          className="menu-button"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          <MenuIcon />
        </button>
      </div>
    </header>
  );
}
